export default __webpack_public_path__ + "static/media/3536 spice rack D top.cc1825d7.png";